export default __webpack_public_path__ + "static/media/banner.73de52b4.jpeg";